export default {
  "help": {
    "popup": {
      "title": {
        "newhand": "Just registered? Get help from our support team",
        "label": "Need help?"
      },
      "phone": {
        "time": "Availability: 02:00 - 11:00 GMT",
        "desc": "Speak to us over the phone",
        "number": "Call：+86 27-8282 2869",
        "label": "Phone"
      },
      "helpcenter": {
        "time": "Availability: 24/7",
        "desc": "24/7 online forum with articles written by our support team and our users.",
        "label": "Support Center"
      },
      "webchat": {
        "time": "Availability: 9:00 - 18:00 GMT",
        "desc": "Text chat with our friendly support staff online",
        "label": "Online Chat"
      },
      "enquirenow": "Ask a question >"
    }
  },
  "logout": "Sign Out",
  "webpos": {
    "offline": "Offline"
  },
  "reserve": {
    "popup": {
      "noThanks": "reserve.popup.noThanks",
      "title": "reserve.popup.title",
      "reserve": {
        "range": "reserve.popup.reserve.range",
        "informWay": {
          "phone": "reserve.popup.reserve.informWay.phone",
          "email": "reserve.popup.reserve.informWay.email"
        },
        "choose": {
          "informWay": "reserve.popup.reserve.choose.informWay"
        }
      },
      "sure": "reserve.popup.sure"
    }
  },
  "restaurant": {
    "setting": "Settings"
  },
  "consult": {
    "popup": {
      "noThanks": "consult.popup.noThanks",
      "title": "consult.popup.title",
      "reserveConsultTime": "consult.popup.reserveConsultTime",
      "chatOnline": "consult.popup.chatOnline",
      "technical": {
        "installationAndUse": "consult.popup.technical.installationAndUse",
        "support": "consult.popup.technical.support",
        "aboutSystem": "consult.popup.technical.aboutSystem",
        "featuresAndBuy": "consult.popup.technical.featuresAndBuy"
      }
    }
  },
  "pos": {
    "booking": {
      "search": "Booking ID",
      "failed": "I'm sorry. We haven't found any booking with ID: __orderNo__",
      "confirm": "Are you sure you want to associate booking for __name__ (__phone__) for __count__ persons on __date__ to this bill?",
      "display": "__orderNo__: __name__ (__phone__) x __count__"
    },
    "search": "Search",
    "bill": {
      "status": {
        "label": "Bill Status"
      }
    },
    "generate": {
      "demo": {
        "data": "Demo Data"
      }
    },
    "save": "Save",
    "status": {
      "paid": "Paid",
      "closed": "Available",
      "unpaid": "Unpaid",
      "all": "All",
      "mobile": {
        "order": "Mobile Order"
      }
    },
    "screensize": {
      "caution": "Caution"
    },
    "menu": {
      "item": {
        "short": {
          "code": "Shortcut Code"
        }
      }
    },
    "settings": {
      "member": "Membership",
      "sales": "Sales Reports",
      "menu": "Menu",
      "table": "Table",
      "restaurant": "General",
      "license": "Subscription",
      "user": "Staff",
      "print": "Printer",
      "discount": "Discount"
    },
    "back": {
      "to": {
        "settings": "Back"
      }
    },
    "experience": {
      "restaurant": {
        "alert": "You are using a trial account. Click here to register.",
        "alertshort": "Click to register your account."
      }
    },
    "label": {
      "table": {
        "switch": "Switch",
        "close": "Close Table"
      }
    },
    "table": {
      "item": {
        "billList": "Today's Bills",
        "status": "Status",
        "refund": "Cancel Item"
      },
      "modal": {
        "billItems": "Ordered items"
      }
    },
    "analytics": {
      "data": "Analytics"
    },
    "header": {
      "queue": "",
      "booking": "",
      "help": "Help",
      "weixin": "Wechat",
      "overview": "Tables",
      "order": "Order",
      "stats": "Statistics",
      "settings": "Settings",
      "activity": "Promotions",
      "license": "Lincense",
      "cashier": "Check",
      "online": {
        "order": "Online Menu"
      }
    },
    "printer": {
      "open": "Printer plugin is ready",
      "status": "Printer status",
      "unconfig": "You haven't configured a printer",
      "receipt": {
        "diner": {
          "total": {
            "count": {
              "label": "# of diners"
            }
          }
        }
      },
      "offline": "Please open the Chrome Printing Plugin",
      "close": "Printer plugin is not active"
    },
    "setting": {
      "needRefresh": "Please click to refresh",
      "settingSaved": "Saved"
    },
    "order": {
      "submit": "Place Order",
      "bill": {
        "total": {
          "amount": "Total"
        }
      },
      "table": {
        "select": "Select"
      },
      "confirm": {
        "yes": "OK"
      }
    },
    "experience": {
      "restaurant": {
        "alert": "You have signed-in to a demonstration restaurant. Please <a>click here</a> to register your own account."
      }
    },
    "confirm": "OK",
    "activity": {
      "menu": "pos.activity.menu",
      "feature": {
        "weixin": "pos.activity.feature.weixin",
        "analytics": "pos.activity.feature.analytics"
      },
      "join": "pos.activity.join",
      "day": "pos.activity.day",
      "license": "pos.activity.license"
    },
    "cashier": {
      "add": {
        "note": "Notes",
        "booking": "Associate Booking"
      },
      "choose": {
        "waiter": "Waiting Staff"
      },
      "addnote": {
        "placeholder": "e.g. nut allergy, kosher"
      }
    },
    "mobile": {
      "order": {
        "experience": {
          "restaurant": {
            "register": "",
            "alert": ""
          }
        },
        "hint": "Generate a QR Code for the selected service staff, then scan the code on a mobile device to open the mobile ordering function."
      },
      "create": "Generate"
    },
    "webchat": {
      "zopim": {
        "title": "Click to chat with us!"
      }
    },
    "reload": "Please do not refresh on the offline mode, otherwise you will lose data!",
    "error": "There was a temporary error loading the system. Please click OK to refresh the page.",
    "network": {
      "slow": "Network is slow, please wait",
      "dead": "Network Error",
      "checking": "Checking Network...",
      "done": "Network is normal, please be patient.",
      "failed": "Network Error: Please check and then press 'Refresh'",
      "refresh": "Refresh"
    }
  }
}


// WEBPACK FOOTER //
// ./src/locales/en-US/translation.js